<main class="main-home-secton">
  <div class="event-main">
    <div class="container">
      <div class="div-header">
        <h1>Blog</h1>
      </div>
      <div class="div-contents" *ngIf="noData == false">
        <div class="row">
          <div
            class="col-lg-4 col-md-4 col-sm-6 col-12"
            *ngFor="let list of disList; let i = index"
          >
            <div class="blog-div">
              <div class="blog-img-div">
                <div
                  id="carouselCaptions{{ list.id }}"
                  class="carousel slide"
                  data-ride="carousel"
                >
                  <div class="carousel-inner">
                    <div
                      class="carousel-item carosal{{ j }}"
                      *ngFor="let image of list.blogImages; let j = index"
                    >
                      <img
                        [src]="image.blogImageName"
                        class="d-block blog-img"
                        alt="..."
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="blog-titles">
                <h5 class="c-pointer" (click)="blogGet(list.id)">
                  {{ list.blogName }}
                </h5>
                <p>{{ list.blogShortDescription }}</p>
                <div class="blog-footer">
                  <div class="d-flex">
                    <div class="mr-3">
                      <ion-icon name="time-outline"></ion-icon>
                      {{ list.createdDate }} ago
                    </div>
                    <div>
                      <ion-icon name="eye-outline"></ion-icon>
                      {{ list.viewedCount }} read
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="div-contents" *ngIf="noData == true">
        <div class="text-center no-data-div">
          <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
          <h6>Coming soon</h6>
        </div>
      </div>
    </div>
  </div>
</main>
<app-footer></app-footer>
